<div class="wizard-container">
    <div class="top-section">
        <div class="wizard-header">
            <div class="image-container">
                <img [src]="wizard.wizardSvg | assetVersion" [style.--svg-url]="'url(' + wizard.wizardSvg + ')'"
                    alt="wizard-logo" class="wizard-logo">
            </div>
            <div class="wizard-text-content">
                <div class="wizard-title">{{ wizard.title }}</div>
                <div class="wizard-description">{{ wizard.description }}</div>
            </div>
        </div>
        <div class="wizard-steps">
            <div class="wizard-step-item active">1</div>
            <div class="step-divider" [ngClass]="{'active': currentStep() > 1}"></div>
            <div class="wizard-step-item" [ngClass]="{'active': currentStep() > 1}">2</div>
            <div class="step-divider" [ngClass]="{'active': currentStep() > 2}"></div>
            <div class="wizard-step-item" [ngClass]="{'active': currentStep() > 2}">3</div>
        </div>
    </div>
    <div class="content-section">
        @switch (currentStep()) {
        @case (1) {
        <div class="title-container">
            <div class="section-title">What do you want to improve today?</div>
            <div class="section-description">Select the focus areas and specific questions you'd like {{ polarisName }}
                to analyze.</div>
        </div>
        <form [formGroup]="wizardForm" class="wizard-form">
            @if (focusAreasFormArray.length > 0) {
            @for (focusAreaGroup of focusAreasFormArray.controls; track $index) {
            <app-copilot-wizard-focus-areas [title]="getFocusAreaTitle($index)"
                [subQuestions]="getFocusAreaSubQuestions($index)" [titleSelected]="getFocusAreaTitleSelected($index)"
                [subSelected]="getFocusAreaSubSelected($index)">
            </app-copilot-wizard-focus-areas>
            }
            }
        </form>
        }
        @case (2) {
        <div class="title-container">
            <div class="section-title">Set your dimensions and filters</div>
            <div class="section-description">Narrow down the analysis by selecting specific brands, time ranges, and
                regions.</div>
        </div>
        <form [formGroup]="wizardForm" class="wizard-form">
            <div class="form-section">
                <div class="logo-label-container">
                    <img [src]="'svg/grey-brand.svg' | assetVersion">
                    <label class="form-label">My Brand (Optional)</label>
                </div>
                <app-select-menu [control]="brandsControl" [items]="brandOptions()" [selectMode]="SelectMode.SINGLE"
                    [width]="'100%'" [placeholder]="'Select a brand'" [searchable]="brandOptions().length > 6"
                    [showSelectedIcon]="true">
                </app-select-menu>
            </div>

            <div class="form-section">
                <div class="logo-label-container">
                    <img [src]="'svg/competitors.svg' | assetVersion">
                    <label class="form-label">Competitors (Optional)</label>
                </div>
                <app-select-menu [control]="competitorsControl" [items]="competitorOptions()"
                    [selectMode]="SelectMode.MULTI" [width]="'100%'"
                    [placeholder]="brandControlValue() ? 'Select competitors' : 'Select a brand first'"
                    [disabled]="!brandControlValue() || competitorOptions().length === 0"
                    [searchable]="competitorOptions().length > 6" [selectAllAndClearOptions]="true"
                    [showAllSelectedIcons]="true">
                </app-select-menu>
            </div>

            <div class="form-section">
                <div class="logo-label-container">
                    <img [src]="'svg/calendar.svg' | assetVersion">
                    <label class="form-label">Date Range</label>
                </div>
                <app-date-picker [range]="dateRangeGroup">
                </app-date-picker>
            </div>

            <div class="form-section countries-section">
                <div class="logo-label-container">
                    <img [src]="'svg/globe.svg' | assetVersion">
                    <label class="form-label">Countries (Optional)</label>
                </div>
                <app-select-menu [control]="countriesControl" [items]="countriesOptions()"
                    [selectMode]="SelectMode.MULTI" [width]="'100%'" [placeholder]="'Select countries'"
                    [searchable]="countriesOptions().length > 6" [selectAllAndClearOptions]="true"
                    [showAllSelectedIcons]="true" [dropDownWideWidth]="true" [dropDownPosition]="'top'"
                    [dropDownSide]="'left'" [iconShape]="'flag'">
                </app-select-menu>
            </div>
        </form>
        }
        @case (3) {
        <form [formGroup]="wizardForm" class="wizard-form">
            <div class="title-container">
                <div class="section-title">Almost there, {{ userName() }}!</div>
                <div class="section-description">Add any final notes or additional instructions to help {{ polarisName
                    }} generate the perfect analysis for you.</div>
                <div class="summary-section-title">Your Analysis Summary</div>
                <div class="summary-content">
                    <div class="summary-item">
                        Focus Areas: <span class="summary-value">{{ selectedFocusAreasCount() }} selected</span>
                    </div>
                    <div class="summary-item">
                        Questions: <span class="summary-value">{{ selectedQuestionsCount() }} selected</span>
                    </div>
                    <div class="summary-item">
                        My Brand: <span class="summary-value">{{ selectedBrandName() || 'Not selected' }}</span>
                    </div>
                    <div class="summary-item">
                        Competitors: <span class="summary-value">{{ selectedCompetitorsNames().length > 0 ?
                            selectedCompetitorsNames().join(', ') : 'None selected' }}</span>
                    </div>
                    <div class="summary-item">
                        Countries: <span class="summary-value">{{ selectedCountriesNames().length > 0 ?
                            selectedCountriesNames().join(', ') : 'None selected' }}</span>
                    </div>
                </div>
                <div class="summary-section-title">Additional Notes (Optional)</div>
                <div class="additional-notes-input-container">
                    <input type="text" class="additional-notes-input" formControlName="additionalPrompt"
                        placeholder="Please focus on...">
                    <div class="additional-notes-description">These notes will be included in your {{ polarisName }}
                        prompt to ensure the analysis meets your specific needs.</div>
                </div>
            </div>
        </form>
        }
        }
    </div>
    <div class="bottom-section">
        <button class="previous-button" (click)="previousStep()">
            <img [src]="'svg/arrow-left.svg' | assetVersion"> Back</button>
        @if (currentStep() < totalSteps) { <button class="next-button" (click)="nextStep()">
            Next <img [src]="'svg/arrow-right.svg' | assetVersion">
            </button>
            } @else {
            <button class="submit-button" (click)="submit()">Generate with {{ polarisName }} <img
                    [src]="'svg/ai-star-white.svg' | assetVersion"></button>
            }
    </div>
</div>
